import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const index =  r => require.ensure([], () => r(require('@/views/index')), 'index');
const list =  r => require.ensure([], () => r(require('@/views/list')), 'list');
const detail =  r => require.ensure([], () => r(require('@/views/detail')), 'detail');
const error =  r => require.ensure([], () => r(require('@/views/error')), 'error');


export default new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            name: '',
            component: index
        },
        {
            path: '/index',
            name: 'index',
            component: index
        },
        {
            path: '/list',
            name: 'list',
            component: list
        },
        {
            path: '/detail',
            name: 'detail',
            component: detail
        },
        {
            path: '/error',
            name: 'error',
            component: error
        }
    ]
})
